// extracted by mini-css-extract-plugin
module.exports = {"SectionC":"SectionC_SectionC___FatM"};